import React from 'react'
import PropTypes from 'prop-types'

// Exports
export const Value = ({attr, record, renderer}) => {
  let node = null

  if (renderer && typeof renderer[attr] === 'function') {
    node = renderer[attr](record, attr, record[attr])
  } else {
    node = record[attr]
  }

  if (node != null) {
    return (
      <div data-test='CellValue'>{node}</div>
    )
  }

  return null
}

Value.propTypes = {
  attr: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  renderer: PropTypes.objectOf(PropTypes.func),
}

export default Value
